// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/containers/PublisherEnterprisePackagePage.scss
// module id = 1621
// module chunks = 0